import { lazy } from "react";

// Deploy removes previous hashed chunks (sync --delete). An open tab then
// rejects the import, and React.lazy keeps that rejection, so the error
// boundary's Try again cannot fetch the new file. Retry once for a blip,
// then reload. The session key stores that reload time and blocks another
// reload for a minute, so a failed refresh cannot loop and a later deploy
// in the same tab can still recover.
export const CHUNK_RELOAD_SESSION_KEY = "dople_chunk_reload_once";
export const CHUNK_RELOAD_WINDOW_MS = 60 * 1000;

function reloadBlocked() {
  const raw = window.sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY);
  const reloadedAt = Number(raw);
  if (!raw || !Number.isFinite(reloadedAt)) return false;
  return Date.now() - reloadedAt < CHUNK_RELOAD_WINDOW_MS;
}

export function loadWithRetry(importer) {
  const attempt = () => Promise.resolve().then(importer);
  return attempt().catch(() => attempt()).catch((error) => {
    if (!reloadBlocked()) {
      window.sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, String(Date.now()));
      window.location.reload();
    }
    throw error;
  });
}

export function lazyWithRetry(importer) {
  return lazy(() => loadWithRetry(importer));
}
